//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let loading;
  import {
    mapState,
    mapMutations
  } from 'vuex'
  import {
    cartInfo,
    orderPlace,
    updateCart,
    getCartNum,
    campaignRule,
    userInfo
  } from '@/service/index'

  export default {
    data() {
      return {
        multipleSelection: [],
        centerDialogVisible: false,
        deleteVisible: false,
        selectedDeletePro: {},
        total: 0,
        allQty: 0,
        selectAll: false,
        cartInfoList: [],
        rule: {},
        isLoading: true,
        point: null,
        points: null,
        user:null,
        addressVisible: false,
        address: '',
        name: '',
        addressLoading: false
      }
    },
    computed: {
      ...mapState([
        'global', 'categories', 'campaign', 'bread', 'goods', 'specName', 'specNameEn'
      ]),
      specNames() {
        return this.$i18n.locale === 'en' ? this.specNameEn : this.specName;
      }
    },
    methods: {
      ...mapMutations({
        initCartNum: 'INIT_CART_NUM',
      }),
      async getUserInfo() {
        const res = await userInfo(this.$route.query.cid)
        if (res.status === 0) {
          this.user = res.data
          this.point = res.data.point
          this.points = res.data.points
          //          this.recordUserinfo(res.data)
        }
      },
      clearFocus(self) {
        window.document.activeElement.blur()
      },
      goToDetails(productId) {
        this.$router.push({
          name: 'goodDetail',
          query: {
            id: productId,
            cid: this.$route.query.cid
          }
        });
      },
      toggleSelection(rows) {
        if (rows && !this.selectAll) {
          this.selectAll = true;
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        } else if (!this.selectAll) {
          this.selectAll = true;
          for (let i = 0; i < this.cartInfoList.length; i++) {
            this.$refs.multipleTable.toggleRowSelection(this.cartInfoList[i], true);
          }
        } else {
          this.selectAll = false
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.total = 0;
        this.allQty = 0;
        val.forEach(item => {
          this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
          this.allQty += item.qty;
        })
      },
      async changeCount(row) {
        const param = {};
        param.items = [];
        param.items.push({
          qty: row.qty,
          productId: row.productId
        })
        const res = await updateCart(this.$route.query.cid, param)
        if (res.status === 0) {
          this.total = 0;
          this.allQty = 0;
          this.$refs.multipleTable.selection.forEach(item => {
            this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
            this.allQty += item.qty;
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({
            cartNum: cartRes.data
          })
        } else {
          row.qty = row.qty - 1;
          if (res.status === 2) {
            this.$message(this.$t("cartMsg.lackall"));
          } else if (res.status === 3) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.lackall"));
          } else if (res.status === 4) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.globalamount"));
          } else if (res.status === 5) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.perskuqty"));

          } else if (res.status === 6) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.globalqty"));

          } else if (res.status === 7) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.typeqty"));

          } else if (res.status === 8) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.catqty"));

          } else if (res.status === 9) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.orderqty"));

          } else if (res.status === 10) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.pointlack"));
          } else if (res.status === 11) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.personalamount"));
          } else {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.retry"));
          }
        }
      },
      submitData() {
        // this.$confirm('一个人只有' + this.rule.orderQty + '次下单机会，一经付款，订单就不可取消和修改，您依然确定要下单吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   const id = this.orderPlace(this.multipleSelection);
        // }).catch(() => {
        // });
        if (this.rule.orderQty === -1 || this.rule.orderQty === 100000) {
          if(!this.user) return false
          // if (this.user.email.indexOf('@')<0) {
          if(true){
            this.$prompt('Please enter your HKID / Passport full name for verification upon pickup！', '', {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              customClass:'download-invoice',
              inputPattern: /./,
              inputErrorMessage: 'Please enter your HKID / Passport full name'
            }).then(({
              value
            }) => {
              // 新增地址选择
              this.addressVisible = true
              this.name = value
              // this.orderPlace(value)
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '取消输入'
              // });
            });
          } else {
            this.orderPlace()
          }

        } else {
          this.centerDialogVisible = true;
        }

      },
      onConfirmAddress(){
        if(!this.address){
          return this.$message('Please select an address!');
        }
        loading = this.$loading({
          lock: true,
          text: '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'fullscree-loading'
        });
        this.orderPlace()
      },
      submitFilter(data) {
        return data / 1 === 0;
      },
      goBack() {
        //        goback可能不存在
        this.$router.push({
          path: `/home/${this.$route.query.cid}`,
          query: {
            cid: this.$route.query.cid
          }
        })
      },
      async getCartInfo() {
        const res = await cartInfo(this.$route.query.cid);
        this.isLoading = false
        if (res.status === 0) {
          this.cartInfoList = res.data
          this.$nextTick(function () {
            this.toggleSelection()
          })
        }
      },
      async getCampaignRuleInfo() {
        const res = await campaignRule(this.$route.query.cid);
        if (res.status === 0) {
          this.rule = res.data
        }
      },
      async orderPlace(email) {
        // alert(email)
        this.centerDialogVisible = false
        const param = {
          address: this.address
        };
        param.items = [];
        if(this.name){
          param.name=this.name
        }
        this.multipleSelection.map(item => {
          param.items.push({
            productId: item.productId,
            qty: item.qty
          })
        })
        const res = await orderPlace(this.$route.query.cid, param);
        loading.close()
        if (res.status === 0) {
          this.$router.push({
            path: `/orderDetail/${res.data.order.id}`,
            query: {
              cid: this.$route.query.cid
            }
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({
            cartNum: cartRes.data
          })
        } else if (res.status === 2) {
          this.$message(this.$t("placeorder.lack"));
          const obj = this;
          setTimeout(
            function () {
              obj.$router.push({
                path: `/orderDetail/${res.data.order.id}`,
                query: {
                  cid: obj.$route.query.cid
                }
              });
            }, 3000)
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({
            cartNum: cartRes.data
          })
        } else if (res.status === 3) {
          this.$message(this.$t("placeorder.lackall"));
        } else if (res.status === 4) {
          this.$message(this.$t("placeorder.globalamount"));
        } else if (res.status === 5) {
          this.$message(this.$t("placeorder.perskuqty"));
        } else if (res.status === 6) {
          this.$message(this.$t("placeorder.globalqty"));
        } else if (res.status === 7) {
          this.$message(this.$t("placeorder.typeqty"));
        } else if (res.status === 8) {
          this.$message(this.$t("placeorder.catqty"));
        } else if (res.status === 9) {
          this.$message(this.$t("placeorder.orderqty"));
        } else if (res.status === 10) {
          this.$message(this.$t("placeorder.pointlack"));
        } else if (res.status === 11) {
          this.$message(this.$t("placeorder.personalamount"));
        } else {
          this.$message(this.$t("placeorder.retry"));
        }
      },
      selectDelete(item) {
        this.deleteVisible = true
        this.selectedDeletePro = item;
      },
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
        this.$i18n.locale = 'en';
      },
      async deletePro() {
        this.deleteVisible = false;
        const param = {};
        param.items = [];
        param.items.push({
          qty: 0,
          productId: this.selectedDeletePro.productId
        })
        const res = await updateCart(this.$route.query.cid, param)
        if (res.status === 0) {
          this.$message({
            message: 'Successfully Removed',
            type: 'success'
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({
            cartNum: cartRes.data
          })
          // this.getCartInfo()
          this.deleteCart(this.selectedDeletePro)
        }
      },
      deleteCart(cart) {
        for(var i = 0 ; i < this.cartInfoList.length ; i++) {
          var c = this.cartInfoList[i]
          if(c.id == cart.id) {
            this.cartInfoList.splice(i, 1)
          }
        }
      }
    },
    mounted() {
      this.getUserInfo();
      this.getCartInfo();
      this.getCampaignRuleInfo();
      this.keepLang();
    },

  }




// WEBPACK FOOTER //
// ./src/pages/cart/CartPc.vue